import { render, staticRenderFns } from "./NewNodeDialog.vue?vue&type=template&id=77bf0406&scoped=true"
import script from "./NewNodeDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewNodeDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewNodeDialog.vue?vue&type=style&index=0&id=77bf0406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf0406",
  null
  
)

export default component.exports